import { render } from "./PartnershipOnboardingKYC.vue?vue&type=template&id=09f396be&scoped=true&ts=true"
import script from "./PartnershipOnboardingKYC.vue?vue&type=script&lang=ts"
export * from "./PartnershipOnboardingKYC.vue?vue&type=script&lang=ts"

import "./PartnershipOnboardingKYC.vue?vue&type=style&index=0&id=09f396be&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f396be"]])

export default __exports__